import { HttpError } from 'react-admin';

export const requireAuth = (): string => {
  const token = sessionStorage.getItem('token');
  if (!token) {
    throw new HttpError('Authentication token not found', 401);
  }
  return token;
};
